import { SceneGeometryCache } from './sceneGeometryCache';

/**
 * TODO: Refactor and attach different instances of SceneGeometryCache to each SceneReconciler.
 */
export class SceneGeometryModule {
  private readonly _geometryCache: SceneGeometryCache;

  /**
   * Constructor.
   */
  constructor() {
    this._geometryCache = new SceneGeometryCache();
    SceneGeometryModule._instance = this;
  }

  dispose() {
    // empty
  }

  get geometryCache() {
    return this._geometryCache;
  }

  // static

  private static _instance: SceneGeometryModule;

  /**
   * Gets module instance.
   */
  static get instance() {
    return SceneGeometryModule._instance;
  }
}
